var prevData = [];
var previousData = [];

export const sortProcessesWeeklyView = (data=[]) => {
    return data;
    const doneProcesses  = data.filter(i=>i.done || i.quantity === i.finished)
    const activeProcesses = data.filter(i => !i.done && i.quantity !== i.finished && !i?.start_date)
    // const sortedActiveProcesses = activeProcesses.sort((a,b)=> a.original_process_date < b.original_process_date ? -1 : a.original_process_date === b.original_process_date ? 0 : 1)
    const moreThanOneDayProcesses = data.filter(i =>  !i.done && i.quantity !== i.finished && i?.start_date) 
    const sortedMoreThanOneDayProcesses = moreThanOneDayProcesses.sort((a,b)=> a.start_date < b.start_date ? -1 : a.start_date === b.start_date ? 0 : 1) 
    return [...sortedMoreThanOneDayProcesses, ...activeProcesses, ...doneProcesses]

}
 

export const sortProcessesMonthlyView = (data = []) => {
    return [...data].sort((a, b) => {
        const sortKeyA = a.proccess?.sortKey ?? Infinity;
        const sortKeyB = b.proccess?.sortKey ?? Infinity;

        if (sortKeyA !== sortKeyB) {
            return sortKeyA - sortKeyB;
        }

        const isSegmentA = a.proccess?.isSegment ?? false;
        const isSegmentB = b.proccess?.isSegment ?? false;

        return (isSegmentA ? 0 : 1) - (isSegmentB ? 0 : 1);
    });
};


export const sortProcessesMonthlyRView = (date = "", data = []) => {
  if (!Array.isArray(data)) return [];

  // 1️⃣ Split done & active per user (immutable)
  const doneMap = new Map();
  const activeMap = new Map();

  data.forEach(x => {
    if (!x || !Array.isArray(x.value)) return;

    const done = [];
    const active = [];

    x.value.forEach(i => {
      if (i?.proccess?.done || i?.proccess?.quantity === i?.proccess?.finished) {
        done.push(i);
      } else if (
        !i?.proccess?.done &&
        i?.proccess?.quantity !== i?.proccess?.finished &&
        !i?.proccess?.start_date
      ) {
        active.push(i);
      }
    });

    doneMap.set(x.key, {
      key: x.key,
      value: done,
      heightWouldBe: x.heightWouldBe,
      user_name: x.user_name,
      overloaded: x.overloaded
    });

    activeMap.set(x.key, active);
  });

  // 2️⃣ Merge done + active without mutation
  const currentData = [];

  doneMap.forEach((doneEntry, key) => {
    const activeValues = activeMap.get(key) || [];

    currentData.push({
      ...doneEntry,
      value: [...doneEntry.value, ...activeValues]
    });
  });

  return currentData;
};